import { Component, Input } from '@angular/core';
import {
  CtButtonConfiguration,
  CtModelConfiguration,
  DeleteConfirmService,
  MAT_RAISED_PRIMARY,
  MAT_RAISED_WARN
} from "@ctsolution/ct-framework";

/**
 * Component per la visualizzazione di un singolo place del contact
 * 
 * Responsabilità:
 * - Mostra il form per un place (indirizzo, città, ecc.)
 * - Gestisce i pulsanti Salva e Elimina per il place
 * - Delega le azioni al parent tramite configuration callbacks
 * 
 * Pattern utilizzato:
 * - Presentational component (riceve tutto via @Input)
 * - Configuration-driven UI
 * - Callbacks per comunicazione con parent
 */
@Component({
  selector: 'app-contact-place',
  template: `
    <div class="contact-place-container" *ngIf="configuration">

      <mat-card>

        <mat-card-content>

          <mat-card-title>

            <h5 style="margin: 0px">{{ 'CustomerLocation' | translate }} {{ idx ?? -1 }}</h5>

          </mat-card-title>

          <div class="ct-model-container">

            <ct-model [configuration]="configuration"></ct-model>

          </div>

          <mat-card-actions *ngIf="configuration?.form">

            <ct-button [configuration]="cancelButton"></ct-button>

            <ct-button [configuration]="submitButton"></ct-button>

          </mat-card-actions>

        </mat-card-content>

      </mat-card>

    </div>
  `,
  styles: [`
    ::ng-deep .contact-place-container {

      .mat-card-actions {

        display: flex;
        justify-content: space-between;

      }

      .ct-model-container {

        .mat-card {

          margin: 0px;
          box-shadow: none !important;

          .mat-card-content {

            padding: 0px !important;

          }

        }

      }

    }
  `]
})
export class ContactPlaceComponent {

  /** Configurazione del place con form e callbacks */
  @Input() configuration: CtModelConfiguration<any> | null = null;
  
  /** Indice del place nella lista (per il titolo) */
  @Input() idx: number | null = null;

  /** Pulsante di submit */
  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.submit())
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  /** Pulsante di delete */
  cancelButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("delete")
    .setAction(() => {

      this.deleteConfirm
        .open()
        .afterClosed()
        .subscribe((result?: boolean) => {

          if (result) {
            // Chiama il callback onDelete della configuration
            this.configuration?.onDelete!({ index: (this.idx ?? 1) - 1 });
            return;
          }

        });

    })
    .setMatherialOptions(MAT_RAISED_WARN);

  constructor(private deleteConfirm: DeleteConfirmService) {}

  /**
   * Gestisce il submit del place
   * Valida il form e chiama il callback onCreate della configuration
   */
  submit() {

    // Valida il form
    this.configuration?.form?.markAllAsTouched();

    if (this.configuration?.form?.valid) {

      // Chiama il callback onCreate della configuration
      this.configuration?.onCreate!(this.configuration.form.value);

    }

  }
}
